import supplierapply from '@/view/supplier-apply';

const supplier = {
    install:function (Vue) {
        Vue.component('supplier',supplierapply)
    }
}
export default supplier;